import { General } from "../../../siteManagement/general.js";
import { FAIcon } from "../../core/components/faIcon.js";
import { Config } from "../../core/config/config.js";
import { Helper } from "../../core/util/helper.js";
import { HTTPService } from "../../core/util/httpManager.js";
import React from "react";
export class TicketView extends React.Component<{ ticket: Ticket, bookmark: Bookmark }, any>{

    private parseDate = (value: Date | string) => {
        const date = Helper.dates.toDate(value);
        return kendo.toString(date, 'D');
    }

    private onClick = async () => {
        const data = await HTTPService.noBusyIndicator().get<any>("SmartSearchPreview/TicketHighlights", { id: this.props.bookmark.id });
        const highlights = data.matches.map((x) => x.text);
        const sheet = General.Sheet.Manager.createSheetWithUrl(`Procedure/EditByGuid?isguid=${this.props.ticket.IsGuid}`);
        sheet.setExternalData({ textToHighlight: highlights });
    }

    private renderComments = () => {
        const renderComment = (comment: string) => {
            return (
                <div style={{ display: "flex", minHeight: "25px", marginBottom: "3px" }}>
                    <FAIcon name="comment-alt" prefix={"fal"} style={{ justifyContent: "center", display: "flex", width: "25px", height: "25px", alignItems: "center" }} />
                    <div style={{ marginLeft: "10px", flex: 1, display: "flex", alignItems: "center" }}>
                        {comment}
                    </div>

                </div>
            );
        }

        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                {Helper.isNullOrEmpty(this.props.ticket.FirstComment) ? null : renderComment(this.props.ticket.FirstComment)}
                {(Helper.isNullOrEmpty(this.props.ticket.LastComment) || this.props.ticket.FirstComment == this.props.ticket.LastComment) ? null : renderComment(this.props.ticket.LastComment)}
            </div>
        );
    }

    private renderInfoView = () => {
        const ticket = this.props.ticket;
        return (
            <div style={{ height: "100%", display: "grid", gridTemplateRows: "45px repeat(4, 25px) 1fr 1fr", gridTemplateColumns: "25px 10px auto", cursor: "pointer" }} onClick={this.onClick}>
                <FAIcon name="exclamation-square" prefix={"fal"} style={{ gridRow: "1/8", gridColumn: "1/4", alignItems: "center", justifyContent: "center", display: "flex", fontSize: "16em", opacity: "0.1", zIndex: -1 }} />
                <div style={{ gridRow: "1/2", gridColumn: "1/4", alignItems: "center", justifyContent: "center", display: "flex", fontSize: "medium", padding: "5px", lineHeight: "20px", fontWeight: "bold" }}>
                    <a target="_blank" onClick={(e) => e.stopPropagation()} href={Config.baseUrl + `Procedure/EditByGuid?isguid=${this.props.ticket.IsGuid}`}>{ticket.Title}
                    </a>
                </div>
                <FAIcon name={ticket.IsContainer ? "users" : "user"} prefix={"fal"} style={{ gridRow: "2/3", gridColumn: "1/2", alignItems: "center", justifyContent: "center", display: "flex" }} />
                <div style={{ gridRow: "2/3", gridColumn: "3/4", alignItems: "center", display: "flex" }}>
                    {Helper.isNullOrEmpty(ticket.Hotliner) ? "n/a" : ticket.Hotliner}
                </div>
                <FAIcon name="calendar" prefix={"fal"} style={{ gridRow: "3/4", gridColumn: "1/2", alignItems: "center", justifyContent: "center", display: "flex" }} />
                <div style={{ gridRow: "3/4", gridColumn: "3/4", alignItems: "center", display: "flex" }}>
                    {this.parseDate(ticket.Deadline)}
                </div>
                <FAIcon name="question" prefix={"fal"} style={{ gridRow: "4/5", gridColumn: "1/2", alignItems: "center", justifyContent: "center", display: "flex" }} />
                <div style={{ gridRow: "4/5", gridColumn: "3/4", alignItems: "center", display: "flex" }}>
                    {ticket.TicketType}
                </div>
                <FAIcon name="heart-rate" prefix={"fal"} style={{ gridRow: "5/6", gridColumn: "1/2", alignItems: "center", justifyContent: "center", display: "flex" }} />
                <div style={{ gridRow: "5/6", gridColumn: "3/4", alignItems: "center", display: "flex" }}>
                    {ticket.Status}
                </div>
                <div style={{ gridRow: "6/8", gridColumn: "1/4" }}>
                    {this.renderComments()}
                </div>
            </div>
        );
    }

    private renderDeleted = () => {
        return (
            <div style={{ display: "grid", height: "100%" }}>
                <div style={{ display: "flex", justifyContent: "center", gridArea: "1/1/1/1", alignItems: "center", height: "100%" }}>
                    <i className={`fal fa-times fa-10x`} style={{ opacity: 0.1, fontSize: "225px" }}></i>
                </div>
                <div style={{ textAlign: "center", gridArea: "1/1/1/1", paddingTop: "25%", height: "100%" }}>
                    <label style={{ fontSize: "15px" }}>
                        {Helper.getTranslation("SmartSearch.TicketIsDeleted")}
                    </label>
                </div>
            </div>
        );
    }


    render() {
        const ticket = this.props.ticket;
        return Helper.hasValue(ticket) ? this.renderInfoView() : this.renderDeleted();
    }
}

interface Ticket {
    ProblemNr: number;
    Title: string;
    FirstComment: string;
    LastComment: string;
    IsContainer: boolean;
    Hotliner: string;
    TicketType: string;
    Status: string;
    Deadline: Date | string;
    IsGuid: string;
}